import { graphql, useStaticQuery } from 'gatsby';

const usePost = () => {

    const data = useStaticQuery(graphql`
        query {
            allInstaNode(limit: 3, sort: { fields: timestamp, order: DESC }) {
                edges {
                    node {
                        id
                        likes
                        comments
                        mediaType
                        timestamp
                        caption
                        localFile {
                            childImageSharp {
                                fixed(width: 355, height: 355) {
                                    ...GatsbyImageSharpFixed
                                }
                            }
                        },
                    }
                }
            }
        }
    `);

    // console.log(data.allInstaNode.edges);

    return data.allInstaNode.edges.map(edge => ({
        id: edge.node.id,
        likes: edge.node.likes,
        comments: edge.node.comments,
        mediaType: edge.node.mediaType,
        timestamp: edge.node.timestamp,
        caption: edge.node.caption,
        localFile: edge.node.localFile
    }));
}
 
export default usePost;